import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Box, Typography, Button, Paper } from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";
import { canAccessClipsCompany } from "../pages/clips/clipsAccess";

interface ClipsRouteProps {
  children: React.ReactNode;
}

/** Avoid importing Layout (circular: Layout → ClipsRoute). */
const AUTH_PATH = "/auth";

const ClipsRoute: React.FC<ClipsRouteProps> = ({ children }) => {
  const { isAuthenticated, hasProductAccess, getDefaultRoute, user } =
    useAuth();
  const canAccessClips =
    hasProductAccess("clips") && canAccessClipsCompany(user?.companyId);
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return <Navigate to={AUTH_PATH} replace />;
  }

  if (!canAccessClips) {
    const defaultRoute = getDefaultRoute();
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
          p: 3,
        }}
      >
        <Paper
          elevation={0}
          variant="outlined"
          sx={{
            p: 4,
            maxWidth: 450,
            textAlign: "center",
            borderRadius: 2,
          }}
        >
          <LockIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
          <Typography variant="h5" gutterBottom fontWeight="bold">
            Clips no disponible
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            No tienes acceso a Clips.
          </Typography>
          {defaultRoute !== AUTH_PATH && (
            <Button
              variant="contained"
              onClick={() => navigate(defaultRoute)}
              sx={{ mt: 1 }}
            >
              Ir a inicio
            </Button>
          )}
        </Paper>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ClipsRoute;
